import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from './Home';
import { LANDINGS } from './landings/registry';

// Every landing is code-split: an ad visitor downloads only their own page.
const pages = LANDINGS.map((l) => ({ slug: l.slug, Component: lazy(l.load) }));

export default function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Home />} />
          {pages.map(({ slug, Component }) => (
            <Route key={slug} path={`/landing/${slug}`} element={<Component />} />
          ))}
          {/* unknown URL -> home index */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
